import React from 'react'
import ItalyBloreCertMain from './ItalyBloreCertMain'
import "./../../UaeAttestation/UaeService/UaeService.css";
import AustraliaBloreCertHead from '../../Australia/AustraliaBloreCert/AustraliaBloreCertHead';
const ItalyBloreCert = () => {
  return (
    <div className="uaeServiceContainer">
    <AustraliaBloreCertHead head="Italy Apostille service in Bangalore for certificates" />
    <ItalyBloreCertMain />
  </div>
  )
}

export default ItalyBloreCert
